import Vue from 'vue';
import Router from 'vue-router';

import { isAuth, isNotAuth } from './guard';

Vue.use(Router);

const routes = [
    {
        path: '',
        redirect: '/login',
        component: () => import('@/views/layouts/app'),
        children: [
            {
                path: '/history',
                beforeEnter: isAuth,
                component: () => import('@/views/pages/History'),
                meta: {
                    permission: ['intern', 'operator', 'manager', 'boss', 'admin', 'corporate-admin', 'corporate-user', 'admin-delivery', 'manager-establishment', 'admin-establishment', 'manager-establishment-ext'],
                    name: 'history'
                }
            },
            {
                path: 'driver-news/editor/:id',
                name: 'driverArticleEditor',
                beforeEnter: isAuth,
                component: () => import('@/views/pages/DriverArticleEditor'),
                meta: {
                    permission: ['admin'],
                    name: 'driverArticleEditor'
                }
            },
            {
                path: 'add-driver-article',
                name: 'addDriverArticle',
                beforeEnter: isAuth,
                component: () => import('@/views/pages/AddDriverArticle'),
                meta: {
                    permission: ['admin'],
                    name: 'addDriverArticle'
                }
            },
            {
                path: 'driver-news',
                name: 'articleList',
                beforeEnter: isAuth,
                component: () => import('@/views/pages/DriverNews'),
                meta: {
                    permission: ['admin'],
                    name: 'articleList'
                }
            },
            {
                path: '/delivery-reports',
                beforeEnter: isAuth,
                component: () => import('@/views/pages/DeliveryReports'),
                meta: {
                    permission: ['admin-establishment', 'admin-delivery', 'admin'],
                    name: 'deliveryReports'
                }
            },
            {
                path: '/import-products',
                beforeEnter: isAuth,
                component: () => import('@/views/pages/Delivery/ImportProducts'),
                meta: {
                    permission: ['admin-establishment', 'admin-delivery', 'admin'],
                    name: 'importProducts'
                }
            },
            ...['/dashboard-map', '/dashboard-map/:id'].map(path => ({
                path,
                beforeEnter: isAuth,
                component: () => import('@/views/pages/DashboardMap'),
                meta: {
                    permission: ['boss', 'admin', 'manager', 'accountant'],
                    name: 'map',
                    notUseContainer: true
                }
            })),
            {
                path: '/finances',
                redirect: '/finances/tariffs',
                component: () => import('@/views/layouts/finances'),
                children: [
                    {
                        path: 'tariffs',
                        beforeEnter: isAuth,
                        component: () => import('@/views/pages/Tariffs'),
                        meta: {
                            permission: ['admin', 'manager', 'boss'],
                            requireExtendedCapabilities: true,
                            name: 'finances',
                            useTitle: true
                        }
                    },
                    {
                        path: 'commissions',
                        beforeEnter: isAuth,
                        component: () => import('@/views/pages/Commissions'),
                        meta: {
                            permission: ['admin', 'manager', 'boss'],
                            requireExtendedCapabilities: true,
                            name: 'finances',
                            useTitle: true
                        }
                    },
                    {
                        path: 'commission-systems',
                        beforeEnter: isAuth,
                        component: () => import('@/views/pages/CommissionSystems'),
                        meta: {
                            permission: ['admin'],
                            name: 'finances',
                            useTitle: true
                        }
                    },
                    {
                        path: 'penalties',
                        beforeEnter: isAuth,
                        component: () => import('@/views/pages/Penalties'),
                        meta: {
                            permission: ['admin', 'manager', 'boss'],
                            requireExtendedCapabilities: true,
                            name: 'finances',
                            useTitle: true
                        }
                    },
                    {
                        path: 'option-classes',
                        beforeEnter: isAuth,
                        component: () => import('@/views/pages/OptionClasses'),
                        meta: {
                            permission: ['admin', 'boss', 'manager'],
                            name: 'finances',
                            useTitle: true
                        }
                    }/*,
                    {
                        path: 'payment-types',
                        beforeEnter: isAuth,
                        component: () => import('@/views/pages/PaymentTypes'),
                        meta: {
                            permission: ['admin', 'boss', 'manager'],
                            name: 'finances',
                            useTitle: true
                        }
                    }*/
                ]
            },
            ...['/finances/commissions/editor', '/finances/commissions/editor/:id'].map(path => ({
                path,
                beforeEnter: isAuth,
                component: () => import('@/views/pages/CommissionEditor'),
                meta: {
                    permission: ['manager', 'boss', 'admin'],
                    name: 'finances',
                    useTitle: true
                }
            })),
            ...['/finances/commission-systems/editor', '/finances/commission-systems/editor/:id'].map(path => ({
                path,
                beforeEnter: isAuth,
                component: () => import('@/views/pages/CommissionSystemsEditor'),
                meta: {
                    permission: ['admin'],
                    name: 'finances',
                    useTitle: true
                }
            })),
            ...['/finances/penalties/editor', '/finances/penalties/editor/:id'].map(path => ({
                path,
                beforeEnter: isAuth,
                component: () => import('@/views/pages/PenaltyEditor'),
                meta: {
                    permission: ['manager', 'boss', 'admin'],
                    name: 'finances',
                    useTitle: true
                }
            })),
            ...['/finances/tariffs/editor', '/finances/tariffs/editor/:id'].map(path => ({
                path,
                beforeEnter: isAuth,
                component: () => import('@/views/pages/OptionEditor'),
                meta: {
                    permission: ['manager', 'boss', 'admin'],
                    name: 'finances',
                    useTitle: true
                }
            })),
            {
                path: '/users',
                redirect: '/users/drivers',
                component: () => import('@/views/layouts/users'),
                children: [
                    {
                        path: 'drivers',
                        beforeEnter: isAuth,
                        component: () => import('@/views/pages/Drivers'),
                        meta: {
                            permission: ['operator', 'accountant', 'manager', 'boss', 'admin'],
                            name: 'users',
                            useTitle: true
                        }
                    },
                    {
                        path: 'clients',
                        beforeEnter: isAuth,
                        component: () => import('@/views/pages/Clients'),
                        meta: {
                            permission: ['operator', 'admin', 'admin-delivery'],
                            name: 'users',
                            useTitle: true
                        }
                    },
                    {
                        path: 'operators',
                        beforeEnter: isAuth,
                        component: () => import('@/views/pages/Operators'),
                        meta: {
                            permission: ['admin', 'corporate-admin', 'admin-delivery', 'admin-establishment'],
                            name: 'users',
                            useTitle: true
                        }
                    }
                ]
            },
            ...['/operators/editor', '/operators/editor/:id'].map(path => ({
                path,
                beforeEnter: isAuth,
                component: () => import('@/views/pages/OperatorEditor'),
                meta: {
                    permission: ['admin', 'manager', 'corporate-admin', 'admin-delivery', 'admin-establishment'],
                    name: 'users',
                    useTitle: true
                }
            })),
            ...['/drivers/editor', '/drivers/editor/:id'].map(path => ({
                path,
                beforeEnter: isAuth,
                component: () => import('@/views/pages/DriverEditor'),
                meta: {
                    permission: ['operator', 'accountant', 'manager', 'boss', 'admin'],
                    name: 'users',
                    useTitle: true
                }
            })),
            ...['/clients/editor', '/clients/editor/:id'].map(path => ({
                path,
                beforeEnter: isAuth,
                component: () => import('@/views/pages/ClientEditor'),
                meta: {
                    permission: ['operator', 'manager', 'boss', 'admin'],
                    name: 'users',
                    useTitle: true
                }
            })),
            {
                path: '/bonuses',
                redirect: '/bonuses/client',
                component: () => import('@/views/layouts/bonuses'),
                children: [
                    {
                        path: 'client',
                        beforeEnter: isAuth,
                        component: () => import('@/views/pages/ClientBonuses'),
                        meta: {
                            permission: ['admin'],
                            name: 'bonuses',
                            useTitle: true
                        }
                    },
                    {
                        path: 'driver',
                        beforeEnter: isAuth,
                        component: () => import('@/views/pages/DriverBonuses'),
                        meta: {
                            permission: ['admin'],
                            name: 'bonuses',
                            useTitle: true
                        }
                    }
                ]
            },
            ...['/bonuses/client/editor', '/bonuses/client/editor/:id'].map(path => ({
                path,
                beforeEnter: isAuth,
                component: () => import('@/views/pages/ClientBonusesEditor'),
                meta: {
                    permission: ['admin', 'boss'],
                    name: 'bonuses',
                    useTitle: true
                }
            })),
            ...['/bonuses/driver/editor', '/bonuses/driver/editor/:id'].map(path => ({
                path,
                beforeEnter: isAuth,
                component: () => import('@/views/pages/DriverBonusesEditor'),
                meta: {
                    permission: ['admin', 'boss'],
                    name: 'bonuses',
                    useTitle: true
                }
            })),
            {
                path: '/login',
                beforeEnter: isNotAuth,
                component: () => import('@/views/pages/Login'),
                meta: {
                    name: 'login'
                }
            },
            {
                path: '/notifications',
                beforeEnter: isAuth,
                component: () => import('@/views/pages/Notifications'),
                meta: {
                    permission: ['boss', 'admin', 'manager'],
                    name: 'notifications'
                }
            },
            {
                path: '/forms',
                beforeEnter: isAuth,
                component: () => import('@/views/pages/Forms'),
                meta: {
                    permission: ['admin'],
                    name: 'forms'
                }
            },
            ...['/forms/editor', '/forms/editor/:id'].map(path => ({
                path,
                beforeEnter: isAuth,
                component: () => import('@/views/pages/FormEditor'),
                meta: {
                    permission: ['admin'],
                    name: 'forms'
                }
            })),
            {
                path: '/form-answers',
                beforeEnter: isAuth,
                component: () => import('@/views/pages/FormAnswers'),
                meta: {
                    permission: ['admin', 'operator', 'manager'],
                    name: 'formAnswers'
                }
            },
            {
                path: '/reports',
                beforeEnter: isAuth,
                component: () => import('@/views/pages/Reports'),
                meta: {
                    permission: ['accountant', 'manager', 'boss', 'admin', 'corporate-admin', 'corporate-user', 'leader'],
                    name: 'reports'
                }
            },
            {
                path: '/reports/list',
                beforeEnter: isAuth,
                component: () => import('@/views/pages/ReportsList'),
                meta: {
                    permission: ['admin'],
                    name: 'reports'
                }
            },
            ...['/reports/editor', '/reports/editor/:id'].map(path => ({
                path,
                beforeEnter: isAuth,
                component: () => import('@/views/pages/ReportsEditor'),
                meta: {
                    permission: ['admin'],
                    name: 'reports'
                }
            })),
            {
                path: '/addresses',
                beforeEnter: isAuth,
                component: () => import('@/views/pages/Addresses'),
                meta: {
                    permission: ['operator', 'admin', 'intern', 'corporate-user'],
                    name: 'addresses'
                }
            },
            {
                path: '/settings',
                redirect: '/settings/admin',
                component: () => import('@/views/layouts/settings'),
                children: [
                    {
                        path: 'admin',
                        beforeEnter: isAuth,
                        component: () => import('@/views/pages/Settings'),
                        meta: {
                            permission: ['admin', 'boss'],
                            settingRole: 'admin',
                            name: 'settings',
                            useTitle: true,
                            requireExtendedCapabilities: true
                        }
                    },
                    {
                        path: 'boss',
                        beforeEnter: isAuth,
                        component: () => import('@/views/pages/Settings'),
                        meta: {
                            permission: ['admin', 'boss'],
                            settingRole: 'boss',
                            name: 'settings',
                            useTitle: true,
                            requireExtendedCapabilities: true
                        }
                    }
                ]
            },
            {
                path: '/resales',
                component: () => import('@/views/pages/ResalesList'),
                beforeEnter: isAuth,
                meta: {
                    permission: ['admin'],
                    name: 'resales'
                }
            },
            {
                path: 'brands',
                beforeEnter: isAuth,
                component: () => import('@/views/pages/Brands'),
                meta: {
                    permission: ['admin', 'admin-delivery'],
                    name: 'brands'
                }
            },
            ...['/brands/editor', '/brands/editor/:id'].map(path => ({
                path,
                beforeEnter: isAuth,
                component: () => import('@/views/pages/BrandEditor'),
                meta: {
                    permission: ['admin', 'admin-delivery'],
                    name: 'brands'
                }
            })),
            {
                path: '/photo-report',
                redirect: '/photo-report/reason-create',
                component: () => import('@/views/pages/PhotoReport'),
                children: [
                    {
                        path: 'reasons',
                        beforeEnter: isAuth,
                        component: () => import('@/views/pages/PhotoReport/ReasonRequestsList'),
                        meta: {
                            permission: ['admin', 'manager'],
                            name: 'photoReport.reasons'
                        }
                    },
                    {
                        path: 'request-create',
                        beforeEnter: isAuth,
                        component: () => import('@/views/pages/PhotoReport/PhotoReportCreate'),
                        meta: {
                            permission: ['admin', 'manager'],
                            name: 'photoReport.requestCreate'
                        }
                    },
                    {
                        path: 'reports',
                        beforeEnter: isAuth,
                        component: () => import('@/views/pages/PhotoReport/PhotoReportsList'),
                        meta: {
                            permission: ['admin', 'manager'],
                            name: 'photoReport.reports'
                        }
                    },
                    {
                        path: ':id',
                        beforeEnter: isAuth,
                        component: () => import('@/views/pages/PhotoReport/PhotoReportReview'),
                        meta: {
                            permission: ['admin', 'manager'],
                            name: 'photoReport.review'
                        }
                    }
                ]
            },
            {
                path: '/logging',
                beforeEnter: isAuth,
                component: () => import ('@/views/pages/Logging'),
                meta: {
                    permission: ['admin'],
                    name: 'logging'
                }
            },
            {
                path: '/logging/editor',
                beforeEnter: isAuth,
                component: () => import ('@/views/pages/LoggingEditor'),
                meta: {
                    permission: ['admin'],
                    name: 'loggingEditor'
                }
            },
            {
                path: '/technical-support',
                beforeEnter: isAuth,
                component: () => import('@/views/pages/TechnicalSupport'),
                meta: {
                    permission: ['operator', 'admin'],
                    name: 'technicalSupport',
                }
            },
            {
                path: '/establishments-categories',
                beforeEnter: isAuth,
                component: () => import('@/views/pages/Delivery/EstablishmentsCategories'),
                meta: {
                    permission: ['admin', 'admin-delivery'],
                    name: 'establishmentsCategories',
                }
            },
            {
                path: '/establishments-types',
                beforeEnter: isAuth,
                component: () => import('@/views/pages/Delivery/EstablishmentsTypes'),
                meta: {
                    permission: ['admin', 'admin-delivery'],
                    name: 'establishmentsTypes',
                }
            },
            {
                path: '/establishments',
                beforeEnter: isAuth,
                component: () => import('@/views/pages/Delivery/EstablishmentsList'),
                meta: {
                    permission: ['admin', 'admin-delivery'],
                    name: 'establishments',
                }
            },
            ...['/establishments/editor', '/establishments/editor/:id'].map(path => ({
                path,
                beforeEnter: isAuth,
                component: () => import('@/views/pages/Delivery/EstablishmentEditor'),
                meta: {
                    permission: ['admin', 'admin-delivery'],
                    name: 'establishments'
                }
            })),
            {
                path: '/sections',
                beforeEnter: isAuth,
                component: () => import('@/views/pages/Delivery/Sections'),
                meta: {
                    permission: ['admin', 'admin-delivery', 'admin-establishment'],
                    name: 'sections',
                }
            },
            {
                path: '/products',
                beforeEnter: isAuth,
                component: () => import('@/views/pages/Delivery/ProductsList'),
                meta: {
                    permission: ['admin', 'admin-delivery', 'admin-establishment', 'manager-establishment-ext'],
                    name: 'products',
                }
            },
            ...['/products/editor', '/products/editor/:id'].map(path => ({
                path,
                beforeEnter: isAuth,
                component: () => import('@/views/pages/Delivery/ProductEditor'),
                meta: {
                    permission: ['admin', 'admin-delivery', 'admin-establishment'],
                    name: 'products'
                }
            })),
        ]
    },
    {
        path: '/receive-orders',
        beforeEnter: isAuth,
        component: () => import('@/views/pages/ReceiveOrders'),
        meta: {
            permission: ['operator', 'admin', 'intern', 'corporate-user', 'admin-delivery', 'admin-establishment', 'manager-establishment', 'manager-establishment-ext']
        }
    },
    {
        path: '/*',
        beforeEnter: isAuth,
        component: () => import('@/views/pages/Error/404'),
        meta: {
            permission: ['intern', 'operator', 'manager', 'boss', 'admin', 'accountant', 'corporate-admin', 'corporate-user', 'admin-delivery', 'admin-establishment', 'manager-establishment', 'manager-establishment-ext'],
            name: 404
        }
    }
];

export default new Router({
    mode: 'history',
    scrollBehavior: () => ({ y: 0 }),
    routes
});
